export class InMemoryVideoExtractRepository {
    constructor() {
        this.videoExtracts = [];
        this.equalityVideoChoice = 'equality';
    }
    retreiveAllExtracts() {
        return Promise.resolve(this.videoExtracts);
    }
    retreiveEqualityVideoExtracts() {
        return Promise.resolve(this.videoExtracts.filter(videoExtract => videoExtract.choice === this.equalityVideoChoice));
    }
    retreiveVideoExtractsByChoice(majorChoice) {
        return Promise.resolve(this.videoExtracts.filter(videoExtract => videoExtract.choice === majorChoice));
    }
    hasVideoExtract(choice) {
        return Promise.resolve(this.videoExtracts.some(videoExtract => videoExtract.choice === choice));
    }
    hasEqualityVideoExtract() {
        return Promise.resolve(this.videoExtracts.some(videoExtract => videoExtract.choice === this.equalityVideoChoice));
    }
}
